<template>

    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-select
                    :options="form.grupo"
                    defaultOptionText="Todos"
                    label="Grupo"
                    show-default-option
                    text-field="nome"
                    v-model="model.grupoId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-input-autocomplete
                    :repository="repositories.solicitacao.procedimentoCirurgico"
                    :request-query-string-params="requestQueryStringParams"
                    :searchFields="fields.autocompleteprocedimento.procedimento"
                    :text-field="i => `${this.formatProcedimento(i.codigo)} - ${i.nome}`"
                    :validations="validations.procedimento"
                    label="Procedimento"
                    placeholder="Digite o código ou o nome do procedimento"
                    v-model="model.procedimento"
                />
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-button
                    :label="false"
                    @click="$refs.Form.validate(add)"
                    color="primary"
                >
                    Incluir
                </rkm-button>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>

// Mixins.
import { repository, error, formats } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {

    computed: {

        requestQueryStringParams() {

            let procedimentosAdicionadosIds = this.procedimentosAdicionadosIds;

            const object = {
                infraestrutura_solicitante_id: this.infraestruturaSolicitanteId,
                not_id: procedimentosAdicionadosIds,
                regulador_id: this.reguladorId,
                sexo_paciente: this.sexoPaciente,
            }

            if (this.model.grupoId) {

                object.grupo_id = this.model.grupoId;
            }

            return object;
        },
        fields() {

            return {
                autocompleteprocedimento: {
                     procedimento: [
                        { key: 'procedimento_cirurgico.procedimento_codigo', searchable: true },
                        { key: 'procedimento_cirurgico.nome', searchable: true },
                     ]
                },
            }
        },
        validations() {

            return {
                procedimento: { required: true },
            }
        },
        procedimentosAdicionadosIds() {

            return this.procedimentosModal.map(e => e.id)
        }
    },
    created() {

        this.repositories = {
            solicitacao: this.getConectaSusRepository('regulacao.solicitacao'),
        }

        this.load();
    },
    data: () => ({
        model: {
            grupoId: null,
            procedimento: null,
            procedimentos: [],
        },
        form: {
            grupo: [],
        },
    }),
    methods: {

        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading();

            this.repositories.solicitacao.list({
                infraestrutura_solicitante_id: this.infraestruturaSolicitanteId,
                listar: 'grupos-procedimentos-cirurgicos',
                regulador_id: this.reguladorId
            })
            .then(response => {
                this.form.grupo = response.data;
            })
            .catch(this.handleError)
            .finally(this.unsetLoading);
        },
        add() {

            if (this.procedimentosModal.length > 0) {

                this.showWarningNotification(
                    'Só é permitido adicionar um procedimento cirúrgico por solicitação.'
                )

                this.model.procedimento = null;
                return;
            }

            this.procedimentosModal.push(this.model.procedimento);
            this.resetForm();
        },
        resetForm() {

            this.model.procedimento = null;
            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        destroy(procedimento) {

            this.procedimentosModal.splice(this.procedimentosModal.indexOf(procedimento), 1)
        },
    },
    mixins: [repository, error, formats],
    props: {
        infraestruturaSolicitanteId: {type: Number, default: null },
        procedimentosModal: { type: Array, default: () => [] },
        reguladorId: {type: Number, default: null },
        sexoPaciente: { type: [String, Number], default: null },
    },
}
</script>